var _rect, _path, _defs;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMessenger = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_radial_1213_24036)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.8195C6.5 8.47628 9.12027 6 12.4995 6C15.8787 6 18.4989 8.47778 18.4989 11.821C18.4989 15.1642 15.8787 17.6405 12.4995 17.6405C11.892 17.6405 11.3101 17.5595 10.7626 17.4095C10.6561 17.381 10.5421 17.3885 10.4417 17.4335L9.25076 17.9584C8.93878 18.0964 8.58782 17.8744 8.57732 17.534L8.54432 16.4661C8.54132 16.3341 8.48132 16.2111 8.38383 16.1241C7.21694 15.0802 6.5 13.5683 6.5 11.8195ZM10.659 10.7261L8.89669 13.5218C8.7272 13.7903 9.05717 14.0918 9.30915 13.8998L11.202 12.4629C11.3295 12.3654 11.5064 12.3654 11.6354 12.4614L13.0378 13.5128C13.4593 13.8278 14.0592 13.7183 14.3397 13.2729L16.1035 10.4786C16.2715 10.2101 15.9415 9.90716 15.6896 10.0991L13.7967 11.536C13.6693 11.6335 13.4923 11.6335 13.3633 11.5375L11.9609 10.4861C11.5394 10.1711 10.9395 10.2806 10.659 10.7261Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1213_24036",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.12 23.8712) scale(26.1504 26.1481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6098,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9348,
    stopColor: "#FF526C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7661"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessenger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messenger.b6fd5854.svg";
export { ForwardRef as ReactComponent };